import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';

import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import ListItemText from '@material-ui/core/ListItemText';
import Select from '@material-ui/core/Select';
import Checkbox from '@material-ui/core/Checkbox';
import Chip from '@material-ui/core/Chip';

import { addMessage } from '../../../store/actions/message.actions';
import { createNewMetadataAndExecuteRules } from '../../../store/actions/metadata.actions';

const styles = theme => ({
  cell: {
    padding: '0px',
  },
  cellRight: {
    float: 'right',
  },
  select: {
    minWidth: '100%',
  },
  label: {
    paddingRight: '20px',
  },
  buttonBlock: {
    paddingTop: '25px',
    float: 'right',
  },
  input: {
    paddingBottom: '74px',
    width: '100%',
  },
  chips: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  chip: {
    margin: theme.spacing.unit / 4,
  },
  radioGroup: {
    float: 'left',
    height: '100px',
  },
  left: {
    float: 'left',
  },
  right: {
    float: 'right',
  },
  block: {
    width: '100%',
    float: 'left',
  },
  switchBlock: {
    marginTop: '10px',
    width: '100%',
    float: 'left',
  },
  switch: {
    float: 'left',
  },
  switchText: {
    float: 'left',
    paddingTop: '13px',
  },
});

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: (ITEM_HEIGHT * 4.5) + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

class NewColumnDetailContainer extends React.Component {
  constructor(props) {
    super(props);

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChangeName = this.handleChangeName.bind(this);
    this.handleChangeSelect = this.handleChangeSelect.bind(this);
    this.addNewColumn = this.addNewColumn.bind(this);
    this.renderMenuItems = this.renderMenuItems.bind(this);
    this.handleChangeSeparator = this.handleChangeSeparator.bind(this);
    this.handleCustomChange = this.handleCustomChange.bind(this);
    this.handleSyncChange = this.handleSyncChange.bind(this);

    this.state = {
      columnName: '',
      columns: [],
      separator: ' ',
      separatorValue: ' ',
      disabled: true,
    };
  }

  handleSubmit(event) {
    event.preventDefault();
    this.addNewColumn();
  }

  handleCustomChange(event) {
    this.setState({ separatorValue: event.target.value });
  }

  handleSyncChange(event) {
    this.setState({ sync: event.target.checked });
  }

  handleChangeName(event) {
    this.setState({ columnName: event.target.value });
  }

  handleChangeSelect(event) {
    this.setState({ columns: event.target.value });
  }

  handleChangeSeparator(event) {
    if (event.target.value === 'Custom') {
      this.setState({
        separator: event.target.value,
        disabled: false,
      });
    } else {
      this.setState({
        separator: event.target.value,
        separatorValue: event.target.value,
        disabled: true,
      });
    }
  }

  addNewColumn() {
    const {
      columnName, columns, separatorValue, isVirtualFile
    } = this.state;
    const { metadata } = this.props;

    if (columnName.replace(/\s/g, '') === '') {
      this.props.addMessage('error', 'Name cannot be empty');
    } else if (_.some(metadata, column => column.source === columnName)) {
      this.props.addMessage('error', 'Name already in use as source value');
    } else if (_.some(metadata, column => column.name === columnName)) {
      this.props.addMessage('error', 'Name already in use as target value');
    } else {
      // When there is no need for a separator just use empty string
      let sep = '';
      if (columns.length > 1) {
        sep = separatorValue;
      }
      this.props.createNewMetadataAndExecuteRules(columnName, columns, sep, !isVirtualFile);
      this.props.addMessage('success', 'New column added');
      this.props.closeDialog();
    }
  }

  renderMenuItems() {
    return _.map(this.props.metadata, (column, key) => (
      <MenuItem key={key} value={key}>
        <Checkbox checked={this.state.columns.indexOf(key) > -1} />
        <ListItemText primary={column.name} />
      </MenuItem>
    ));
  }

  render() {
    const {
      classes,
      closeDialog,
      metadata,
    } = this.props;

    return (
      <form onSubmit={this.handleSubmit}>
        <Grid md={12} item>
          <Grid className={classes.left} md={7} item>
            <TextField autoFocus className={classes.input} id="name-simple" label="Name" name="Name" onChange={this.handleChangeName} />
            <InputLabel className={classes.label} htmlFor="select-multiple-checkbox">Value from header(s)</InputLabel>
            <Select
              multiple
              className={classes.select}
              value={this.state.columns}
              onChange={this.handleChangeSelect}
              input={<Input id="select-multiple-checkbox" />}
              renderValue={selected => (
                <div className={classes.chips}>
                  {selected.map(value => (
                    <Chip key={value} label={metadata[value].name} className={classes.chip} />
                  ))}
                </div>
              )}
              MenuProps={MenuProps}
            >
              {this.renderMenuItems()}
            </Select>
          </Grid>
          <Grid className={classes.right} md={5} item>
            <FormControl>
              <Typography variant="subtitle1">Separator</Typography>
              <RadioGroup
                className={classes.radioGroup}
                name="joinParameter"
                value={this.state.separator}
                onChange={this.handleChangeSeparator}
              >
                <FormControlLabel value=" " control={<Radio />} label="Space" />
                <FormControlLabel value="\n" control={<Radio />} label="Enter" />
                <FormControlLabel value="," control={<Radio />} label="Comma" />
                <FormControlLabel value="Custom" control={<Radio />} label="Custom" />
              </RadioGroup>
              <TextField
                id="custom-parameter"
                label="Custom separator"
                name="customParameter"
                disabled={this.state.disabled}
                onChange={this.handleCustomChange}
                fullWidth
              />
            </FormControl>
          </Grid>
          <Grid md={12} className={classes.switchBlock} item>
          </Grid>
          <Grid md={12} className={classes.block} item>
            <div className={classes.buttonBlock}>
              <Button onClick={() => closeDialog()} color="primary">
                Cancel
              </Button>
              <Button type="submit" color="primary">
                Save
              </Button>
            </div>
          </Grid>
        </Grid>
      </form>
    );
  }
}

NewColumnDetailContainer.propTypes = {
  isVirtualFile: PropTypes.bool.isRequired,
  metadata: PropTypes.shape({
    key: PropTypes.string,
    name: PropTypes.string,
  }).isRequired,
  closeDialog: PropTypes.func.isRequired,
  createNewMetadataAndExecuteRules: PropTypes.func.isRequired,
  addMessage: PropTypes.func.isRequired,
  /* eslint-disable react/forbid-prop-types */
  classes: PropTypes.object.isRequired,
  /* eslint-enable */
};

export default withStyles(styles)(connect(
  null,
  { addMessage, createNewMetadataAndExecuteRules },
)(NewColumnDetailContainer));
